const USER_KEY = 'ALO47@#369QADB20%-'

module.exports = { USER_KEY }
